
import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
// import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import { withGoogleMap, GoogleMap, withScriptjs, InfoWindow, Marker } from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import {
    Pagination, PaginationItem, PaginationLink,
    Modal, ModalHeader, ModalBody, ModalFooter, Badge
} from "reactstrap";
import { Row, Card, Col, Button, Container } from "react-bootstrap";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { useForm, Controller, FormProvider, useFormContext } from "react-hook-form";
import { CssBaseline, Paper, Box } from "@material-ui/core";
import Select from "react-select";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
// import { NotificationManager } from "react-notifications";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "@material-ui/core/Switch";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { MenuList } from "../../../../../apiservicescall/api";


const initialState = {
    total: 0,
    totalPrice: 0,
    items: {
        'Idly': {
            num: 0,
            img: 'https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100001/3061/1670749057474-download_(3).jpg',
            title: 'Idly',
            price: '30.00',
            description: 'chicken or vegetable',
            meal: 'appetizer'
        },
        'Dosa': {
            num: 0,
            img: 'https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100001/3062/1670749077963-download_(5).jpg',
            title: 'Dosa',
            price: '30.00',
            description: 'skewered chicken or beef with a peanut sauce',
            meal: 'appetizer'
        },
        'Poori': {
            num: 0,
            img: 'https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100001/3066/1670749321686-download_(4).jpg',
            title: 'Poori',
            price: '30.00',
            description: 'fried tofu with a mild chili peanut sauce',
            meal: 'appetizer'
        },
        'Pongal': {
            num: 0,
            img: 'https://fisbuckets.s3.ap-southeast-1.amazonaws.com/outlet/100001/3064/1670749263248-pongal-ven-pongal-500x375.jpg',
            title: 'Pongal',
            price: '30.00',
            description: 'with shrimp in a tamarind sauce',
            meal: 'appetizer'
        }
    }
};

const OrderList = ({ props }) => {
    const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("userDetails")));
    const [ouletMenuMaster, setOuletMenuMaster] = useState([]);

    useEffect(() => {
        
        let outletCode = userDetails?.outletResponses[0]?.outletCode;
        let companyCode = userDetails?.companyCode;
        getoutletList();
    }, []);

    const getoutletList = async () => {
        
        let outletCode = userDetails?.outletResponses[0]?.outletCode;
        let companyCode = userDetails?.companyCode;
        let getoutletList = await MenuList(companyCode, outletCode);
        let getoutletListValue = getoutletList?.data?.data;
        console.log("getoutletListValue", getoutletListValue);
    };
    // http://52.77.35.146:8080/FIS/fetchOutletItem?compCode=1000&outletCode=100002
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'ADD':
            state = {
                ...state,
                total: state.total + action.num,
                totalPrice: state.totalPrice + (state.items[action.title].price * action.num),
                items: {
                    ...state.items,
                    [action.title]: {
                        ...state.items[action.title],
                        num: state.items[action.title].num + action.num
                    }
                }
            };
            break;
        case 'SET':
            state = {
                ...state,
                total: state.total + action.num,
                totalPrice: state.totalPrice + (state.items[action.title].price * action.num),
                items: {
                    ...state.items,
                    [action.title]: {
                        ...state.items[action.title],
                        num: action.num
                    }
                }
            };
            break;
        case 'SUB':
            state = {
                ...state,
                total: state.total - action.num,
                totalPrice: state.totalPrice - (state.items[action.title].price * action.num),
                items: {
                    ...state.items,
                    [action.title]: {
                        ...state.items[action.title],
                        num: state.items[action.title].num - action.num
                    }
                }
            };
            break;
        case 'ZERO':
            state = {
                ...state,
                total: state.total - state.items[action.title].num,
                totalPrice: state.totalPrice - (state.items[action.title].num * state.items[action.title].price),
                items: {
                    ...state.items,
                    [action.title]: {
                        ...state.items[action.title],
                        num: 0
                    }
                }
            };
            break;
        case 'RESET':
            state = initialState;
            break;
    }
    return state;
}
